import React, {useState} from 'react';
import EditHoliday from "./EditHoliday";
import PersistDataGridPro from "../ui/PersistDataGridPro";
import {Button, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import AddHoliday from "./AddHoliday";
import {getMomentDateFromStringNoYear} from "../../utils/getMomentDateFromString";


export default function HolidaysList(props) {

    const columns = [

        {field: 'holiday', numeric: false, disablePadding: false, headerName: 'Holiday', width: 140,
                    valueFormatter: getMomentDateFromStringNoYear,
},
        {field: 'title', numeric: false, disablePadding: false, headerName: 'Title', width: 300},

    ];

    const [open, setOpen] = React.useState(false);
    const [justClicked, setJustClicked] = React.useState(0);
    const [load, setLoad] = React.useState(false);

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const handlePreviousButtonClick = () => {
        setSelectedYear(new Date().getFullYear() - 1);
    };

    const handleCurrentButtonClick = () => {
        setSelectedYear(new Date().getFullYear());
    };
    const handleNextButtonClick = () => {
        setSelectedYear(new Date().getFullYear() + 1);
    };


    const previousYear = new Date().getFullYear() - 1;
    const currentYear = new Date().getFullYear();
    const nextYear = new Date().getFullYear() + 1;

    const handleClose = () => {
        setOpen(false);
        setLoad(!load);
    };

    const handleRowClick = (param) => {
        setJustClicked(param.row);
        setOpen(true);
    };

    return <div >

        <Stack direction="row" spacing={2} justifyContent={"space-between"}>
        <Stack direction="row" spacing={2}>
            <Button
                variant={previousYear === selectedYear ? 'contained' : 'outlined'}
                onClick={handlePreviousButtonClick}
            >
                {previousYear}
            </Button>
            <Button variant={currentYear === selectedYear ? 'contained' : 'outlined'}
                    onClick={handleCurrentButtonClick}>
                {currentYear}
            </Button>
            <Button
                variant={nextYear === selectedYear ? 'contained' : 'outlined'}
                onClick={handleNextButtonClick}
            >
                {nextYear}
            </Button>
        </Stack>
            <AddHoliday handleClose={handleClose}/>
        </Stack>
        <Box margin={2}></Box>
        <PersistDataGridPro
            view={`holidays/${selectedYear}`}
            columns={columns}
            handleRowClick={handleRowClick}
            disableSelectionOnClick
            search={false}
            load={load}
        />

        {open && <EditHoliday holiday={justClicked} handleClose={handleClose}/>}
    </div>;
}